<!-- `no-bullet` is RDS's own opt-out: it ships a global `ul > li::before` blue
     dot that `list-style: none` does not touch.

     `role="list"` because that `list-style: none` strips the list role in
     WebKit, and an `aria-label` on an element demoted to generic is not
     reliably exposed — so without this the group name below is the first thing
     lost, on the one browser where it goes. -->
<ul class="prompt-chips no-bullet" role="list" [attr.aria-label]="label()">
  @for (prompt of prompts(); track prompt) {
    <li>
      <!-- Chip renders on a real button so keyboard users can reach and
           activate it. The type is bound as an attribute rather than set
           statically, because a static value would bind to the chip
           component's own colour input instead of the native button type. -->
      <button
        rds-chip
        size="m"
        [attr.type]="'button'"
        (click)="promptSelected.emit(prompt)"
      >
        {{ prompt }}
      </button>
    </li>
  }
</ul>
